import http from 'hub-http/clients/apiClient';
const BASE_URL = 'forms/v2/permissions';
const fetchFormPermissions = formGuid => {
  return http.get(`${BASE_URL}/${formGuid}`);
};
export default fetchFormPermissions;